import type { FlyzoneMapObject } from "../types";

type NumericValue = number | string;

export interface FlyzoneRaw {
    name: string;
    x_min: NumericValue;
    x_max: NumericValue;
    y_min: NumericValue;
    y_max: NumericValue;
    z_min: NumericValue;
    z_max: NumericValue;
    flyable?: boolean;
    [key: string]: unknown;
}

export function parseFlyzones(
    flyzones: FlyzoneRaw[] | null | undefined,
): FlyzoneMapObject[] {
    if (!Array.isArray(flyzones)) return [];

    return flyzones.map((flyzone) => {
        const x = Number(flyzone.x_min);
        const y = Number(flyzone.y_min);
        const width = Number(flyzone.x_max) - x;
        const height = Number(flyzone.y_max) - y;
        const flyable = flyzone.flyable ?? true;

        return {
            id: `flyzone:${flyzone.name}:${flyable}:${x}:${y}:${width}:${height}`,
            type: "flyzone",
            name: flyzone.name,
            x,
            y,
            width,
            height,
            zMin: Number(flyzone.z_min),
            zMax: Number(flyzone.z_max),
            flyable,
            interactive: true,
        };
    });
}
